import React from 'react'
import { observer } from 'mobx-react-lite'
import Store from './../../store/RoyalRings.store'
import {
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBBtn,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import { UITextarea } from './../../../../components/forms/form-fields'

import './EditModal.component.scss'

const EditModal = () => {
  if (!Store.EditingRecipient) {
    return null
  }

  const handleBioChange = evt => {
    Store.EditingRecipient.set('ring_bio', evt.target.value)
  }

  const handleSave = async () => {
    await Store.save()
  }

  const handleCancel = () => {
    Store.cancelEdit()
  }

  return (
    <MDBModal open={!!Store.EditingRecipient} onClose={handleCancel}>
      <MDBModalDialog size='lg'>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Edit Ring Bio - {Store.getUserNameByRecipient(Store.EditingRecipient)}</MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={handleCancel}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <div className='edit-modal-content'>
              <div className='recipient-info'>
                <p>
                  <strong>User ID:</strong> {Store.EditingRecipient.get('user_id')}
                </p>
                <p>
                  <strong>Ring Type:</strong> {Store.EditingRecipient.get('ring_type')}
                </p>
                <p>
                  <strong>Threshold:</strong> {Store.EditingRecipient.get('ring_threshold')} points
                </p>
              </div>
              <div className='form-group'>
                <UITextarea
                  label='Ring Bio'
                  name='ring_bio'
                  value={Store.EditingRecipient.get('ring_bio') || ''}
                  onChange={handleBioChange}
                  rows={8}
                  placeholder='Enter biographical information about this ring recipient...'
                  rules={{ required: false }}
                />
              </div>
            </div>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type='button' color='secondary' onClick={handleCancel} disabled={Store.isSaving}>
              Cancel
            </MDBBtn>
            <MDBBtn type='button' color='primary' onClick={handleSave} disabled={Store.isSaving}>
              {Store.isSaving ? 'Saving...' : 'Save Changes'}
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

export default observer(EditModal)
